import { action, computed, observable } from 'mobx';

class ViewStore {
  @observable open = false;

  constructor(store, pronto) {
    this.store = store;
    this.pronto = pronto;
  }

  @computed
  get loading() {
    return this.pronto.status === 'pending';
  }

  @computed
  get status() {
    let { status } = this.pronto;
    if (status === 'rejected') return 'error';
    if (status !== 'pending' && !this.report) return 'warn';
    return 'normal';
  }

  @computed
  get report() {
    let { reports } = this.pronto;
    let { details } = this.store;
    let id = (details.get('data') || {}).id;
    return reports.get(id || 0);
  }

  @computed
  get data() {
    if (!this.report || !this.report.draft) return 'Empty';
    return this.report.draft.data;
  }

  @action.bound
  toggleOpen() {
    this.open = !this.open;
  }
}

export default ViewStore;
